"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var Certificate = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Certificate, _Component);

  function Certificate() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Certificate);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Certificate)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "rule", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "data", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(Certificate, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_base.default, {
        type: "certificate",
        target: this.data.rewardFile
      }, _react.default.createElement("div", {
        className: "icon",
        style: {
          backgroundImage: this.item.icon_name ? "url(".concat(this.item.icon_name, ")") : "url(default-images/rewardCertificate)"
        }
      }), _react.default.createElement("h2", {
        className: "name"
      }, this.item.name), _react.default.createElement("h2", {
        className: "count"
      }, "Certificate"));
    }
  }]);
  return Certificate;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "rule", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "data", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = Certificate;